var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.path == `/provider-advisor/bundles`)?_c('Bundles'):_vm._e(),(_vm.path == `/provider-advisor/bundles/builder`)?_c('Builder'):_vm._e(),(_vm.path == `/provider-advisor/bundles/bundle`)?_c('SingleBundle'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }